import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "../../../../../app/hooks";
import { changeForm, airportsSwitch} from "../../../searchFlightsSlice";

function FromToRadioSFO() {
	const direction = useAppSelector(
		(state) => state.searchFlights.form.direction
	)
	const [selValue, setSelValue] = useState(direction)
	const dispatch = useAppDispatch();
  const { t } = useTranslation();
	
  const disabled = useAppSelector((state) => state.searchFlights.form.disabled);
  const onChange = value =>{
		setSelValue(value);
    dispatch(changeForm({ direction: value }));
		dispatch(airportsSwitch());
  }
  return (
		<div className="columns is-mobile">
			<div className="search-bar-item column px-0" id="sfo-from">
				<label
					className="checkbox"
					title={t("RADIO_TITLE_FROM")}
					htmlFor="sfo-radio-from"
				>
					{t("RADIO_FROM_SFO")}
				</label>
				<input
					type="radio"
					defaultChecked={selValue === 'from'}
					disabled={disabled}
					onChange={e => onChange(e.target.value)}
					value="from"
					name="optionForm"
					id="sfo-radio-from"
				/>
			</div>
			<div className="search-bar-item column px-0" id="sfo-from">
				<label
					className="checkbox to-label"
					title={t("RADIO_TITLE_TO")}
					htmlFor="sfo-radio-to"
				>
					{t("RADIO_TO_SFO")}
				</label>
				<input
					type="radio"
					defaultChecked={selValue === 'to'}
					disabled={disabled}
					onChange={e => onChange(e.target.value)}
					value="to"
					name="optionForm"
					id="sfo-radio-to"
				/>
			</div>
		</div>
    
  );
}

export default FromToRadioSFO;